import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full border-t border-zinc-800 bg-zinc-950 py-10" data-id="element-79" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-80" data-mp="3gg118925080a">
        <p className="font-serif text-base font-bold uppercase tracking-[0.3em] text-stone-100" data-id="element-81" data-mp="32o4ao9g4a660">
          Pallavolo <span className="text-yellow-500" data-id="element-82" data-mp="36oxyz3xh1mzf">360™</span>
        </p>
        <p className="mt-3 font-sans text-sm text-stone-400" data-id="element-83" data-mp="36nd1b5fv1nxc">
          Guarda il gesto. Organizza il campo. Guida l'allenamento.
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-yellow-500/50" aria-hidden="true" data-id="element-84" data-mp="38z8yrj06z2w" />
        <p className="mt-6 font-sans text-xs leading-relaxed text-stone-400" data-id="element-85" data-mp="3lelybzm3ebki">
          © 2026 Pallavolo 360 — Tutti i diritti riservati.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-stone-400" data-id="element-86" data-mp="3qblvtm4vm600">
          Sistema digitale di supporto alla pianificazione per allenatori di
          pallavolo. I risultati dipendono dal contesto, dal livello degli
          atleti e da come il materiale viene applicato negli allenamenti
          reali.
        </p>
      </div>
    </footer>;
}